import { FC } from "react";

import { IRideTableDto } from "@ryde/shared";

import { CellLiveMapArrivalTimeStyled } from "../../grid/generic";
import {
  formatLiveMapDelayCounter,
  rideStatusDelayToImage,
} from "../../utils/ride-delay-translate-helpers";
import { IRenderColumnTemplate } from "./_core";

export const LiveMapArrivalDelayCellTemplate: FC<IRenderColumnTemplate> = ({
  rowOriginal,
  value,
}) => {
  const ride = rowOriginal as IRideTableDto | undefined;
  const statusLate = ride?.statusLate;
  const timeDelay =
    typeof value === "number" ? value : (ride?.timeLate ?? undefined);
  const counterText = formatLiveMapDelayCounter(statusLate, timeDelay);
  const showCounter = counterText !== null;
  const delayIcon = rideStatusDelayToImage(statusLate);

  return (
    <CellLiveMapArrivalTimeStyled>
      {delayIcon}
      {showCounter ? <span className="timeDelay">{counterText}</span> : null}
    </CellLiveMapArrivalTimeStyled>
  );
};
